module.exports = __webpack_public_path__ + "img/following-step04.b3db0a2c.svg";